import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface DashboardWidget {
  id: string;
  title: string;
  visible: boolean;
  order: number;
}

interface DashboardPreferencesState {
  widgets: DashboardWidget[];
  setWidgetVisibility: (id: string, visible: boolean) => void;
  reorderWidgets: (widgets: DashboardWidget[]) => void;
  resetToDefaults: () => void;
}

const defaultWidgets: DashboardWidget[] = [
  { id: "priorityTasks", title: "Priority Tasks", visible: true, order: 1 },
  { id: "latestModifiedDocs", title: "Latest Modified Documents", visible: true, order: 2 },
  { id: "pieChart", title: "Top Customers", visible: true, order: 3 },
  { id: "barChart", title: "Production per User", visible: true, order: 4 },
  { id: "bestSellingCategories", title: "Best-selling Categories", visible: true, order: 5 },
  { id: "bestSellingProducts", title: "Best-selling Products", visible: true, order: 6 },
  { id: "lineChart", title: "Evolution of the Business", visible: true, order: 7 },
];

const useDashboardPreferencesStore = create<DashboardPreferencesState>()(
  persist(
    set => ({
      widgets: [...defaultWidgets],
      setWidgetVisibility: (id, visible) =>
        set(state => ({
          widgets: state.widgets.map(widget =>
            widget.id === id ? { ...widget, visible } : widget,
          ),
        })),

      reorderWidgets: widgets => set({ widgets }),
      resetToDefaults: () => set({ widgets: [...defaultWidgets] }),
    }),
    {
      name: "dashboard-preferences",
    },
  ),
);

export default useDashboardPreferencesStore;
